export enum RouteKeys {
  List = '/auction',
  Details = '/auction/:id',
}
